import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import BrandsSinglePersona from './BrandsSinglePersona';
import BrandsDoubleComparisionPersona from './BrandsDoubleComparisionPersona';
import BrandsTripleComparisionPersona from './BrandsTripleComparisionPersona';
import downloadIconDefault from '../../../images/insight360/download-icon_default.png';
import filterIconActive from '../../../images/insight360/filter-icon_active.png';
import FilterSearchComponent from '../../common/FilterSearchComponent';
import clearIcon from '../../../images/insight360/clear-field-icon_190-190-190.png';
import { getFiltersForGivenFamilyId } from '../../../util/CommonUtils';
import { INGSIGHT_360_BRANDS_REPORT_NAME } from '../../../constants';
import { getsortByKeyBasedOnSelectedTab } from '../../../util/Insight360Utils';
import indexIconwhite from '../../../images/index-icon_white.png';
import percentIconWhite from '../../../images/percent-icon_white.png';

class Brands extends Component {
  constructor(props) {
    super(props);
    const selectedBrands = this.props.selectedFilters !== undefined
          ? getFiltersForGivenFamilyId(this.props.selectedFilters,
            this.props.insight360studyInfo.studyFamilyId)
          : [];
    this.state = {
      showFilterSearch: false,
      selectedBrands,
      selectedFilter:
        this.props.selectedFilters !== undefined
          ? this.props.selectedFilters
          : [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.selectedFilter !== nextProps.selectedFilters ||
      this.props.insight360studyInfo.studyFamilyId !== nextProps.insight360studyInfo.studyFamilyId) {
      const selectedBrands = getFiltersForGivenFamilyId(nextProps.selectedFilters,
        nextProps.insight360studyInfo.studyFamilyId);
      this.setState({
        selectedFilter: nextProps.selectedFilters,
        selectedBrands,
      });
    }
  }

  searchFilterFn = (searchVal, callback) => {
    this.props.getfilterSearchResult(
      this.props.componentInfo.category,
      searchVal,
      callback,
    );
  };

  applyFilterFn = filters => {
    this.setState({
      showFilterSearch: false,
    });
    if (filters !== '') {
      this.props.filterSearchApplyFn(
        this.props.componentInfo.category,
        this.getModifiedFilters(filters),
      );
    }
  };

  removeFilterFn = filterVal => {
    const selFilters = _.cloneDeep(this.state.selectedBrands);
    const itemIndex = _.findIndex(selFilters, { value: filterVal });
    selFilters.splice(itemIndex, 1);
    this.props.filterSearchApplyFn(
      this.props.componentInfo.category,
      this.getModifiedFilters(selFilters),
    );
  };

  getModifiedFilters = filters => {
    const studyFamilyId = this.props.insight360studyInfo.studyFamilyId;
    const { selectedFilter } = this.state;
    let modifiedFilters = [];
    if (selectedFilter !== undefined && _.isArray(selectedFilter) && selectedFilter.length > 0) {
      const firstFilter = selectedFilter[0];
      if (firstFilter.studyFamilyId !== undefined) {
        modifiedFilters = _.cloneDeep(selectedFilter);
      }
    }
    const index = _.findIndex(modifiedFilters, { studyFamilyId });
    if (index >= 0) {
      modifiedFilters[index] = { studyFamilyId, filters };
    } else {
      modifiedFilters.push({ studyFamilyId, filters });
    }
    return modifiedFilters;
  }

  closeFilterBox = () => {
    this.setState({
      showFilterSearch: false,
    });
  };

  render() {
    const { selectedTab, sortByKey, pcSortByKey } = this.props;
    return (
      <div id="">
        {this.props.brands !== undefined && this.props.brands.length > 0 && (
          <div
            className="card main-card brandsDoublePersonaPdf overflow-i"
            id=""
          >
            <div className="card-header header-card">
              Brands&nbsp;
              <span style={{ position: 'relative' }}>
                <img
                  className="i360_header_icons_img"
                  src={filterIconActive}
                  alt="filter"
                  onClick={() =>
                    this.setState({
                      showFilterSearch: !this.state.showFilterSearch,
                    })
                  }
                />
                {this.state.showFilterSearch && (
                  <FilterSearchComponent
                    searchFilterFn={this.searchFilterFn}
                    applyFilterFn={this.applyFilterFn}
                    closeFilterBox={this.closeFilterBox}
                    selectedFilter={this.state.selectedBrands}

                  />
                )}
              </span>
              <span className="section-sort-by-index-reach-btns">
                <button
                  type="button"
                  className="section-sort-icon index"
                  title="Index"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'index'),
                  }}
                  onClick={() => {
                    this.props.sectionSortingByIndexAndReach(INGSIGHT_360_BRANDS_REPORT_NAME, 'index');
                  }}
                >
                  <img
                    alt="sort"
                    className="profile-section-sort-icon"
                    src={indexIconwhite}
                  />
                </button>
                <button
                  type="button"
                  className="section-sort-icon reach"
                  title="Reach"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'pct'),
                  }}
                  onClick={() => {
                    this.props.sectionSortingByIndexAndReach(INGSIGHT_360_BRANDS_REPORT_NAME, 'pct');
                  }}
                >
                   <img
                     alt="sort"
                     className="profile-section-sort-icon"
                     src={percentIconWhite}
                   />
                </button>
              </span>
            </div>
            <div className="i360-category-filter-display">
              {this.state.selectedBrands.length > 0 &&
                this.state.selectedBrands.map(selFilter => (<span
                  className="category-filter-item"
                  key={selFilter.value}
                >
                  <img
                    className="i360_header_icons_img"
                    src={clearIcon}
                    alt="Remove"
                    onClick={() => {
                      this.removeFilterFn(selFilter.value);
                    }}
                  />
                  {selFilter.label}
                </span>
                )
                )}
            </div>
            <div
              className="row expanded card-section"
              id="cardOutlook"
              style={{ paddingTop: '0px' }}
            >
              <div className="large-12 medium-12 small-12 columns">
                {this.props.downloadFlag && (
                  <div className="text-right">
                    <img
                      alt="download"
                      onClick={() =>
                        this.props.download(
                          'Brands',
                          'Brands',
                          'brandsPersonaGrid',
                          'personaHeader',
                        )
                      }
                      className="export-icon-class"
                      src={downloadIconDefault}
                    />
                  </div>
                )}
                <div>&nbsp;</div>
              </div>
              <div className="row fullwidth" id="brandsPersonaGrid">
                {this.props.brands !== undefined &&
                  this.props.brands.length === 1 && (<BrandsSinglePersona
                    selectedTab={this.props.selectedTab}
                    brands={this.props.brands[0].brandList}
                    insight360studyInfo={this.props.insight360studyInfo}
                  />
                  )}
                {this.props.brands !== undefined &&
                  this.props.brands.length === 2 && (<BrandsDoubleComparisionPersona
                    brands={this.props.brands}
                    selectedTab={this.props.selectedTab}
                    insight360AttitudeAgreeChoice={
                      this.props.insight360AttitudeAgreeChoice
                    }
                  />
                  )}
                {this.props.brands !== undefined &&
                  this.props.brands.length === 3 && (<BrandsTripleComparisionPersona
                    brands={this.props.brands}
                    selectedTab={this.props.selectedTab}
                    insight360AttitudeAgreeChoice={
                      this.props.insight360AttitudeAgreeChoice
                    }
                  />
                  )}
              </div>
              {this.props.sourceDataInfo()}
            </div>
            <div id={this.props.endId} />
          </div>
        )}
      </div>
    );
  }
}

Brands.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.object),
  download: PropTypes.func,
  sourceDataInfo: PropTypes.func,
  getfilterSearchResult: PropTypes.func,
  filterSearchApplyFn: PropTypes.func,
  componentInfo: PropTypes.shape({
    category: PropTypes.string,
  }),
  selectedFilters: PropTypes.arrayOf(PropTypes.string),
  insight360AttitudeAgreeChoice: PropTypes.string,
  endId: PropTypes.string,
  downloadFlag: PropTypes.string,
  insight360studyInfo: PropTypes.shape({
    studyFamilyId: PropTypes.number,
  }),
  sortByKey: PropTypes.string,
  pcSortByKey: PropTypes.string,
  sectionSortingByIndexAndReach: PropTypes.func,
  selectedTab: PropTypes.string,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    sortByKey: state.insight360.sortByIndexAndReach.brands,
    pcSortByKey: state.insight360.personaCreator.sortByIndexAndReach.brands,
  };
}


export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(Brands);
